'use client'
import { useQuery } from '@tanstack/react-query'
import { searchPagesService } from '@/services/domain/pages/PageService'

/** Busca na central de ajuda. O debounce do termo fica com a tela (`useDebounce`). */
export function usePageSearch(term: string) {
    const normalized = term.trim()

    const query = useQuery({
        queryKey: ['pages-search', normalized],
        queryFn: () => searchPagesService(normalized),
        enabled: normalized.length > 0,
    })

    return {
        results: normalized ? (query.data ?? []) : [],
        isSearching: query.isFetching,
        isError: query.isError,
    }
}
